import {useEffect} from 'react';
import {BrowserRouter, Route, Routes} from "react-router";
import {Amplify} from 'aws-amplify'
import {Authenticator, View} from '@aws-amplify/ui-react';
import outputs from "./amplify_outputs.json";
import {EditPage, MainPage, NavBar} from "./my-components";

Amplify.configure(outputs);

const App = () => {
    useEffect(() => {
        if ('Notification' in window && Notification.permission === 'default') {
            Notification.requestPermission();
        }
    }, []);

    return (
        <Authenticator socialProviders={['google']} variation={"modal"} hideSignUp={true}>
            {({signOut}) => (
                <View maxWidth="500px"
                      margin="0 auto"
                      minHeight="100vh"
                      paddingInline="medium"
                >
                    <BrowserRouter>
                        <NavBar signOut={signOut}/>
                        <main>
                            <Routes>
                                <Route path="/" element={<MainPage/>}/>
                                <Route path="/edit" element={<EditPage/>}/>
                            </Routes>
                        </main>
                    </BrowserRouter>
                </View>
            )}
        </Authenticator>
    )
}
export default App
